import { useApiQuery } from '@common/hooks';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useWarmUpStreamQuery } from '../api';

export const useWarmUpStream = (cdnUrl?: string) => {
    const queryArgs = useMemo(() => {
        if (!cdnUrl || !cdnUrl.includes('media.limecraft')) return skipToken;

        const [baseUrl, token] = cdnUrl.split('?');
        const pingBase = baseUrl
            .replace('media.limecraft.com/files', 'platform.limecraft.com/api')
            .split('/v/')[0];

        return `${pingBase}/data?${token}`;
    }, [cdnUrl]);

    const queryResult = useApiQuery(useWarmUpStreamQuery, queryArgs);

    const isReady =
        queryArgs === skipToken
            ? true
            : queryResult.isSuccess || queryResult.isError;

    return {
        ...queryResult,
        isReady,
    };
};
